import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, FormFeedback } from "reactstrap";

import historyAction from "../../redux/history/action";
import mpAction from "../../redux/microPensionDublicated/action";
import InputComp from "../../component/InputComp/InputComp";
import DatePickerComp from "../../component/DatePicker/DatePicker";
import api from "../../config/api";

class PersonalDetails extends Component {
  state = {
    allStates: [],
    allLGA: [],
    allStates2: [],
    allLGA2: [],
  };

  componentDidMount() {
    const { customRef } = this.props;

    this.fetchFormReferenceNo();
    this.fetchState(null, true);

    customRef({ validate: this.validate });
  }

  fetchFormReferenceNo = async () => {
    const { setPersonalDetailField, formRefno } = this.props;

    try {
      if (!formRefno) {
        const response = await api.fetchFormReferenceNo();
        setPersonalDetailField({ formRefno: response.data.result });
      }
    } catch (e) {
      console.log("e =>", e);
    }
  };

  onSelectChange = (e) => {
    const { setPersonalDetailField } = this.props;
    setPersonalDetailField({ [e.target.name]: e.target.value });
    if (e.target.name === "permanentAddressLocation") {
      this.fetchState(e.target.value);
    }
    if (e.target.name === "permState") {
      this.fetchLGA(e.target.value);
    }
    if (e.target.name === "nationalityCode") {
      this.fetchState2(e.target.value);
    }
    if (e.target.name === "stateOfOrigin") {
      this.fetchLGA2(e.target.value);
    }
  };

  fetchState = async (permanentAddressLocation, dontClear) => {
    try {
      const { user, setPersonalDetailField, permState } = this.props;

      if (!dontClear) {
        setPersonalDetailField({
          permState: "",
          permLga: "",
        });
      }

      if (permState) {
        this.fetchLGA(null, true);
      }

      this.setState({ allStates: [], allLGA: [] });

      if (!permanentAddressLocation) {
        permanentAddressLocation = this.props.permanentAddressLocation;
      }

      if (permanentAddressLocation === "N") {
        permanentAddressLocation = "NG";
      }

      const state = await api.fetchState(
        { countryCode: permanentAddressLocation },
        user.token
      );
      this.setState({ allStates: state.data.result });
    } catch (e) {
      console.log("E =>", e);
    }
  };

  fetchState2 = async (nationalityCode, dontClear) => {
    try {
      const { user, setPersonalDetailField, stateOfOrigin } = this.props;

      if (!dontClear) {
        setPersonalDetailField({
          stateOfOrigin: "",
          lgaCode: "",
        });
      }

      if (stateOfOrigin) {
        this.fetchLGA2(null, true);
      }

      this.setState({ allStates2: [], allLGA2: [] });

      if (!nationalityCode) {
        nationalityCode = this.props.nationalityCode;
      }

      if (nationalityCode === "N") {
        nationalityCode = "NG";
      }

      const state = await api.fetchState(
        { countryCode: nationalityCode },
        user.token
      );
      this.setState({ allStates2: state.data.result });
    } catch (e) {
      console.log("E =>", e);
    }
  };

  fetchLGA = async (permState, dontClear) => {
    try {
      const { user, setPersonalDetailField } = this.props;

      if (!dontClear) {
        setPersonalDetailField({ permLga: "" });
      }

      this.setState({ allLGA: [] });

      if (!permState) {
        permState = this.props.permState;
      }

      const LGA = await api.fetchLGA({ stateCode: permState }, user.token);

      this.setState({ allLGA: LGA.data.result });
    } catch (e) {
      console.log("E =>", e);
    }
  };

  fetchLGA2 = async (stateOfOrigin, dontClear) => {
    try {
      const { user, setPersonalDetailField } = this.props;

      if (!dontClear) {
        setPersonalDetailField({ lgaCode: "" });
      }

      this.setState({ allLGA2: [] });

      if (!stateOfOrigin) {
        stateOfOrigin = this.props.stateOfOrigin;
      }

      const LGA = await api.fetchLGA({ stateCode: stateOfOrigin }, user.token);

      this.setState({ allLGA2: LGA.data.result });
    } catch (e) {
      console.log("E =>", e);
    }
  };

  validate = () => {
    const {
      surname,
      firstname,
      nationalityCode,
      title,
      gender,
      maritalStatusCode,
      permCity,
      ssn,
      mobilePhone,
      formRefno,
      permLga,
      permState,
      placeOfBirth,
      permanentAddressLocation,
      dateOfBirth,
      stateOfOrigin,
      lgaCode,
      // schemeId,
      permCountry,
    } = this.props;

    let isValidated = true,
      formRefnoError = "",
      surnameError = "",
      firstnameError = "",
      nationalityCodeError = "",
      stateOfOriginError = "",
      lgaCodeError = "",
      titleError = "",
      genderError = "",
      maritalStatusCodeError = "",
      permCityError = "",
      permanentAddressLocationError = "",
      mobilePhoneError = "",
      ssnError = "",
      permLgaError = "",
      permStateError = "",
      placeOfBirthError = "",
      dateOfBirthError = "",
      schemeIdError = "",
      permCountryError = "";

    if (!formRefno) {
      formRefnoError = "This field is required";
      isValidated = false;
    }

    // if (!schemeId) {
    //   schemeIdError = "This field is required";
    //   isValidated = false;
    // }

    if (formRefno.length > 50) {
      formRefnoError = "Form number should not exceed 50 characters";
      isValidated = false;
    }
    if (!surname) {
      surnameError = "This field is required";
      isValidated = false;
    }
    if (!firstname) {
      firstnameError = "This field is required";
      isValidated = false;
    }
    if (!nationalityCode) {
      nationalityCodeError = "This field is required";
      isValidated = false;
    }
    if (!stateOfOrigin) {
      stateOfOriginError = "This field is required";
      isValidated = false;
    }
    if (!lgaCode) {
      lgaCodeError = "This field is required";
      isValidated = false;
    }
    if (!title) {
      titleError = "This field is required";
      isValidated = false;
    }
    if (!gender) {
      genderError = "This field is required";
      isValidated = false;
    }
    if (!maritalStatusCode) {
      maritalStatusCodeError = "This field is required";
      isValidated = false;
    }
    if (!permCity) {
      permCityError = "This field is required";
      isValidated = false;
    }

    if (!mobilePhone) {
      mobilePhoneError = "This field is required";
      isValidated = false;
    }
    if (mobilePhone.length !== 11) {
      mobilePhoneError = "Phone number should be 11 digits";
      isValidated = false;
    }
    if (!ssn) {
      ssnError = "This field is required";
      isValidated = false;
    }
    if (ssn.length < 11 || ssn.length > 15) {
      ssnError = "NIN should be under 11-15 digit long";
      isValidated = false;
    }

    if (nationalityCode === "NG" && !permState) {
      permStateError = "This field is required";
      isValidated = false;
    }

    if (nationalityCode === "NG" && !permLga) {
      permLgaError = "This field is required";
      isValidated = false;
    }

    if (!placeOfBirth) {
      placeOfBirthError = "This field is required";
      isValidated = false;
    }

    if (!permanentAddressLocation) {
      permanentAddressLocationError = "This field is required";
      isValidated = false;
    }

    if (!dateOfBirth) {
      dateOfBirthError = "This field is required";
      isValidated = false;
    }

    if (!permCountry) {
      permCountryError = "This field is required";
      isValidated = false;
    }

    this.setState({
      surnameError,
      firstnameError,
      nationalityCodeError,
      titleError,
      genderError,
      maritalStatusCodeError,
      permCityError,
      permanentAddressLocationError,
      mobilePhoneError,
      ssnError,
      formRefnoError,
      permLgaError,
      permStateError,
      dateOfBirthError,
      placeOfBirthError,
      schemeIdError,
      permCountryError,
      stateOfOriginError,
      lgaCodeError,
    });

    return isValidated;
  };

  clearAllErrors = () => {
    this.setState({
      surnameError: "",
      firstnameError: "",
      nationalityCode: "",
      titleError: "",
      genderError: "",
      maritalStatusCodeError: "",
      permCityError: "",
      permanentAddressLocationError: "",
      mobilePhoneError: "",
      ssnError: "",
      schemeId: "",
    });
  };

  render() {
    const {
      formRefno,
      setPersonalDetailField,
      title,
      firstname,
      middleName,
      othernames,
      surname,
      maidenName,
      ssn,
      bvn,
      gender,
      dateOfBirth,
      maritalStatusCode,
      nationalityCode,
      permanentAddressLocation,
      permState,
      permLga,
      mobilePhone,
      permCity,
      placeOfBirth,
      countries,
      // schemeId,
      permCountry,
      stateOfOrigin,
      lgaCode,
    } = this.props;

    const {
      allStates,
      allLGA,
      surnameError,
      firstnameError,
      nationalityCodeError,
      titleError,
      genderError,
      maritalStatusCodeError,
      permCityError,
      mobilePhoneError,
      ssnError,
      formRefnoError,
      permStateError,
      permLgaError,
      placeOfBirthError,
      permanentAddressLocationError,
      dateOfBirthError,
      // schemeIdError,
      permCountryError,
      stateOfOriginError,
      lgaCodeError,
      allStates2,
      allLGA2,
    } = this.state;

    return (
      <div>
        <InputComp
          type="text"
          value={formRefno}
          disabled={true}
          errorMessage={formRefnoError}
          placeholder="Form Reference Number*"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setPersonalDetailField({ formRefno: e.target.value });
          }}
        />
        {/* <InputComp
          type="text"
          value={schemeId}
          errorMessage={schemeIdError}
          placeholder="RSA Scheme ID*"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setPersonalDetailField({ schemeId: e.target.value });
          }}
        /> */}
        <InputComp
          type="text"
          value={surname}
          placeholder="Surname*"
          errorMessage={surnameError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setPersonalDetailField({ surname: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={firstname}
          placeholder="First Name*"
          errorMessage={firstnameError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setPersonalDetailField({ firstname: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={middleName}
          placeholder="Middle Name"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setPersonalDetailField({ middleName: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={othernames}
          placeholder="Other Names"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setPersonalDetailField({ othernames: e.target.value });
          }}
        />
        <Input
          type="select"
          name="nationalityCode"
          className="margin-y-10"
          value={nationalityCode}
          errorMessage={nationalityCodeError}
          invalid={!!nationalityCodeError}
          placeholder="Nationality*"
          containerStyles={{ width: "100%" }}
          onChange={this.onSelectChange}
        >
          <option>Nationality*</option>
          {countries.map((item) => (
            <option key={Math.random().toString()} value={item.countryCode}>
              {item.countryName}
            </option>
          ))}
        </Input>
        {nationalityCodeError && (
          <FormFeedback invalid>{nationalityCodeError}</FormFeedback>
        )}
        <Input
          className="margin-y-10"
          invalid={stateOfOriginError}
          type="select"
          name="stateOfOrigin"
          value={stateOfOrigin || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            State of Origin*
          </option>
          {allStates2.map((item) => (
            <option key={Math.random().toString()} value={item.stateCode}>
              {item.stateName}
            </option>
          ))}
        </Input>
        {!!stateOfOriginError && (
          <FormFeedback invalid>{stateOfOriginError}</FormFeedback>
        )}
        <Input
          className="margin-y-10"
          type="select"
          name="lgaCode"
          invalid={lgaCodeError}
          value={lgaCode || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            LGA Code*
          </option>
          {allLGA2.map((item) => (
            <option key={Math.random().toString()} value={item.lgaCode}>
              {item.lgaName}
            </option>
          ))}
        </Input>
        {!!lgaCodeError && <FormFeedback invalid>{lgaCodeError}</FormFeedback>}
        <Input
          className="margin-y-10"
          type="select"
          name="title"
          id="exampleSelect"
          value={title || "placeholder"}
          onChange={this.onSelectChange}
          invalid={!!titleError}
        >
          <option value="placeholder" selected disabled>
            Title*
          </option>
          <option value="Mr">Mr</option>
          <option value="Mrs">Mrs</option>
          <option value="Miss">Miss</option>
          <option value="Ms">Ms</option>
        </Input>
        {titleError && <FormFeedback invalid>{titleError}</FormFeedback>}
        <Input
          className="margin-y-10"
          type="select"
          name="gender"
          id="exampleSelect"
          value={gender || "placeholder"}
          onChange={this.onSelectChange}
          invalid={!!genderError}
        >
          <option value="placeholder" selected disabled>
            Gender*
          </option>
          <option value="M">Male</option>
          <option value="F">Female</option>
        </Input>
        {genderError && <FormFeedback invalid>{genderError}</FormFeedback>}
        <Input
          className="margin-y-10"
          type="select"
          name="maritalStatusCode"
          id="exampleSelect"
          value={maritalStatusCode || "placeholder"}
          onChange={this.onSelectChange}
          invalid={!!maritalStatusCodeError}
        >
          <option value="placeholder" selected disabled>
            Marital status*
          </option>
          <option value="MD">Married</option>
          <option value="SG">Single</option>
          <option value="DV">Divorced</option>
          <option value="WD">Windowed</option>
          <option value="SP">Sperated</option>
        </Input>
        {maritalStatusCodeError && (
          <FormFeedback invalid>{maritalStatusCodeError}</FormFeedback>
        )}
        <DatePickerComp
          value={dateOfBirth}
          selected={dateOfBirth}
          isError={dateOfBirthError ? true : false}
          errorMessage={dateOfBirthError}
          placeholder="Date of Birth"
          onChange={(e) => {
            setPersonalDetailField({ dateOfBirth: e });
          }}
          containerStyles={{ width: "100%" }}
        />
        <InputComp
          type="text"
          value={placeOfBirth}
          placeholder="Place of Birth"
          containerStyles={{ width: "100%" }}
          errorMessage={placeOfBirthError}
          onChange={(e) => {
            setPersonalDetailField({ placeOfBirth: e.target.value });
          }}
        />
        <Input
          type="select"
          name="permCountry"
          className="margin-y-10"
          value={permCountry}
          errorMessage={permCountryError}
          invalid={!!permCountryError}
          placeholder="Permanent Country*"
          containerStyles={{ width: "100%" }}
          onChange={this.onSelectChange}
        >
          <option>Permanent Country*</option>
          {countries.map((item) => (
            <option key={Math.random().toString()} value={item.countryCode}>
              {item.countryName}
            </option>
          ))}
        </Input>
        <InputComp
          type="text"
          value={permCity}
          placeholder="Permanent City"
          errorMessage={permCityError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setPersonalDetailField({ permCity: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={maidenName}
          placeholder="Maiden/Former Name"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setPersonalDetailField({ maidenName: e.target.value });
          }}
        />
        <Input
          className="margin-y-10"
          type="select"
          name="permanentAddressLocation"
          id="exampleSelect"
          invalid={!!permanentAddressLocationError}
          value={permanentAddressLocation || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Permanent Address Location*
          </option>
          <option value="N">Nigeria</option>
          <option value="A">Abroad</option>
        </Input>
        {!!permanentAddressLocationError && (
          <FormFeedback invalid>{permanentAddressLocationError}</FormFeedback>
        )}
        <Input
          className="margin-y-10"
          invalid={permStateError}
          type="select"
          name="permState"
          value={permState || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Permanent State*
          </option>
          {allStates.map((item) => (
            <option key={Math.random().toString()} value={item.stateCode}>
              {item.stateName}
            </option>
          ))}
        </Input>
        {!!permStateError && (
          <FormFeedback invalid>{permStateError}</FormFeedback>
        )}
        <Input
          className="margin-y-10"
          type="select"
          name="permLga"
          invalid={permLgaError}
          value={permLga || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Permanent LGA*
          </option>
          {allLGA.map((item) => (
            <option key={Math.random().toString()} value={item.lgaCode}>
              {item.lgaName}
            </option>
          ))}
        </Input>
        {!!permLgaError && <FormFeedback invalid>{permLgaError}</FormFeedback>}
        <InputComp
          type="text"
          value={mobilePhone}
          placeholder="Mobile Phone*"
          containerStyles={{ width: "100%" }}
          errorMessage={mobilePhoneError}
          onChange={(e) => {
            setPersonalDetailField({ mobilePhone: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={ssn}
          placeholder="National Identity Number (NIN)"
          errorMessage={ssnError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setPersonalDetailField({ ssn: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={bvn}
          placeholder="Bank Verification Number"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setPersonalDetailField({ bvn: e.target.value });
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  ...state.microPensionDublicated.personalDetail,
  countries: state.onboarding.countries,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setPersonalDetailField: mpAction.setPersonalDetailField,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetails);
